export default "__VITE_ASSET__BXuF2Swu__"